import client from '/src/services/client.js';

export default {
    getConversations : (data) => client.get('conversations/list', data),
    getMarkers:(data)=>client.get(`conversation/markers`,data),
    getRelaunch : (data) => client.get('botjob/list', data),
    getRelaunchID : (instance_id)=> client.get(`relaunch/${instance_id}`),
    getConversation : (instance_id)=> client.get(`conversation/${instance_id}`),
    deleteConversation : (instance_id)=> client.delete(`conversation/${instance_id}`),
    deleteRelaunch : (instance_id)=> client.delete(`botjob/${instance_id}`),
    deleteMarkerFromConversation:(marker_id, conversation_id)=> client.delete(`conversations/${conversation_id}/marker/${marker_id}`),
    addMarkersToConversation:(data,conversation_id)=>client.post(`conversations/${conversation_id}/markers`,data),
    sendConversationByMail: (conversation_id) => client.get(`conversations/mail-convo/${conversation_id}`)
}
